module.exports = __webpack_public_path__ + "static/img/h-banner_01.cc81c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-banner_01.png
// module id = 14
// module chunks = 1